import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useViewMediaStore, usePatientSurgeryStore } from "../../hooks";
import { VideoPlayer, MainButton, SecondaryButton } from "../../ui";
import { PdfViewer } from "../utils";

export const ViewMediaModal = ({ isOpen, setIsOpen }) => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    patientSurgery,
  } = usePatientSurgeryStore();

  const {
    // Props
    hasSeenProcedureVideo,
    hasSeenProcedurePdf,

    // Methods
    startProcedureVideoSeen,
    startProcedurePdfSeen,
    startResetMediaSeen,
  } = useViewMediaStore();

  const { procedure } = patientSurgery.data;

  // States ------------------------------------------------//
  const [stepOnView, setStepOnView] = useState(1);

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  const markVideoAsSeen = () => {
    startProcedureVideoSeen();
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (stepOnView === 2) {
      startProcedurePdfSeen();
    }
  }, [stepOnView]);

  useEffect(() => {
    if (!isOpen && stepOnView > 1) {
      setStepOnView(1);
    }
  }, [isOpen, stepOnView]);

  return (
    <Modal
      show={isOpen}
      onHide={() => setIsOpen(false)}
      centered
      size="xl"
      keyboard={false}
      backdrop="static"
    >
      <Modal.Header>
        <h5 className="modal-title">Información importante</h5>
      </Modal.Header>
      <Modal.Body>
        {stepOnView === 1 && (
          <VideoPlayer
            videoSrc={procedure.urlVideo}
            markVideoAsSeen={() => markVideoAsSeen()}
            containerClass="d-flex justify-content-center align-items-center"
            maxHeight="70vh"
            height="70vh"
          />
        )}

        {stepOnView === 2 && (
          <PdfViewer
            urlPdf={procedure.urlPdf}
            containerClass="d-flex justify-content-center align-items-center"
            maxHeight="70vh"
          />
        )}
      </Modal.Body>
      <Modal.Footer>
        {hasSeenProcedureVideo && stepOnView === 1 && (
          <MainButton
            type="button"
            onClick={() => {
              setStepOnView(2);
            }}
          >
            Siguiente
          </MainButton>
        )}
        {hasSeenProcedureVideo && stepOnView === 2 && (
          <SecondaryButton type="button" onClick={() => setStepOnView(1)}>
            Anterior
          </SecondaryButton>
        )}
        {hasSeenProcedureVideo && hasSeenProcedurePdf && (
          <MainButton type="button" onClick={() => setIsOpen(false)}>
            Finalizar
          </MainButton>
        )}
      </Modal.Footer>
    </Modal>
  );
};
